var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 144,
    viewBox: "0 0 238 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.732422,
    width: 238,
    height: 143,
    rx: 8,
    fill: "#EFF3F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6535_1117507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 64.7324,
    width: 42.6667,
    height: 16,
    fill: "#FAD8D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.667,
    y: 64.7324,
    width: 40,
    height: 16,
    fill: "#F6B1A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.667,
    y: 64.7324,
    width: 14,
    height: 16,
    fill: "#F1897C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.667,
    y: 64.7324,
    width: 42.6667,
    height: 16,
    fill: "#ED6251"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.333,
    y: 64.7324,
    width: 32,
    height: 16,
    fill: "#E83B25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.333,
    y: 64.7324,
    width: 42.6667,
    height: 16,
    fill: "#BF200B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6535_1117507"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 64.7324,
    width: 214,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunities);
export default __webpack_public_path__ + "static/media/communities.a0be2407f9e8aec2d9ce7d8d77d141d7.svg";
export { ForwardRef as ReactComponent };